module.exports = "https://deal-img.imgix.net/consumer/modern/card-bg.58252fb8.jpg";